import { createTheme, Theme } from '@material-ui/core/styles';
import { brown } from '@material-ui/core/colors';

const muiTheme: Theme = createTheme({
  palette: {
    primary: brown,
  },
  typography: {
  },
});

export interface VTheme extends Theme {}

export const theme = muiTheme;
